module.exports = __webpack_public_path__ + "media/images/features/refund/table-comparison-f9a5438daaff1b479d54e6a2f3d60171.svg";